import type { ApiError } from '@/shared/api';

/**
 * Warum etwas an der Anfahrt nicht geklappt hat. Die fachlichen Gründe des Servers sind deutsch
 * und nennen das Feld; ohne Antwort oder bei einem Serverfehler sagt der Text, was tatsächlich
 * los ist — nie „See server logs…“ oder „Failed to fetch“.
 */
export function arrivalProblem(problem: ApiError) {
  if (problem.status === 403) return 'Dafür fehlt Ihnen die Berechtigung.';
  if (problem.status === 0) {
    return 'Keine Antwort vom Server – ob es angekommen ist, ist offen. Bitte prüfen Sie die Verbindung.';
  }
  if (problem.status >= 500) {
    return 'Der Server konnte das gerade nicht erledigen. Bitte versuchen Sie es erneut.';
  }
  return problem.detail ?? 'Der Server hat die Eingabe nicht übernommen.';
}

/** Ohne Antwort oder bei einem Konflikt ist der angezeigte Stand womöglich überholt. */
export const staleAfter = (problem: ApiError) => problem.status === 0 || problem.status === 409;
